import { render } from "./BuyerList.vue?vue&type=template&id=2571be9e&scoped=true"
import script from "./BuyerList.vue?vue&type=script&lang=js"
export * from "./BuyerList.vue?vue&type=script&lang=js"

import "./BuyerList.vue?vue&type=style&index=0&id=2571be9e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2571be9e"]])

export default __exports__